import { render, staticRenderFns } from "./ProductUi.vue?vue&type=template&id=32ae82cc&lang=pug&"
import script from "./ProductUi.vue?vue&type=script&lang=js&"
export * from "./ProductUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports